import main from './image-check.svg';
import active from './image-check-filled.svg';
import disabled from './image-check-gestalt.svg';

export default { main, active, disabled };
